import * as React from "react"

function ExportSvgComponent (props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={22.357}
            height={26.584}
            viewBox="0 0 50.438 39.287"
            {...props}
        >
            <defs>
                <linearGradient
                    id="prefix__a"
                    x1={0.278}
                    y1={-0.083}
                    x2={0.544}
                    y2={0.616}
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset={0} stopColor="#ffe177" />
                    <stop offset={1} stopColor="#fe9738" />
                </linearGradient>
                <linearGradient
                    id="prefix__c"
                    x1={0.333}
                    y1={0.293}
                    x2={0.834}
                    y2={0.914}
                    xlinkHref="#prefix__a"
                />
                <linearGradient
                    id="prefix__b"
                    x1={0.5}
                    y1={0.529}
                    x2={0.5}
                    y2={1.067}
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset={0} stopColor="#fe9738" stopOpacity={0} />
                    <stop offset={1} stopColor="#f46700" />
                </linearGradient>
                <linearGradient
                    id="prefix__d"
                    x1={0.614}
                    y1={0.573}
                    x2={0.231}
                    y2={-0.182}
                    xlinkHref="#prefix__b"
                />
                <linearGradient
                    id="prefix__e"
                    x1={0.437}
                    y1={0.274}
                    x2={0.725}
                    y2={1.094}
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset={0} stopColor="#eef5f6" />
                    <stop offset={1} stopColor="#cbe5e8" />
                </linearGradient>
                <linearGradient
                    id="prefix__f"
                    x1={0.792}
                    y1={0.897}
                    x2={0.446}
                    y2={-0.165}
                    xlinkHref="#prefix__b"
                />
                <linearGradient
                    id="prefix__g"
                    x1={-4.217}
                    y1={6.517}
                    x2={-3.813}
                    y2={7.08}
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset={0} stopColor="#c1e9af" />
                    <stop offset={1} stopColor="#4fc123" />
                </linearGradient>
            </defs>
            <g data-name="Group 1586">
                <g data-name="Group 1584">
                    <path
                        data-name="Path 26196"
                        d="M40.037 95.665H2.849A2.849 2.849 0 010 92.816V59.227a2.849 2.849 0 012.849-2.849h6.068l8.054.989 7.69-.989h15.376a2.849 2.849 0 012.849 2.849v33.589a2.849 2.849 0 01-2.849 2.849z"
                        transform="translate(0 -56.378)"
                        fill="url(#prefix__a)"
                    />
                    <path
                        data-name="Path 26197"
                        d="M31.49 95.665H2.849A2.849 2.849 0 010 92.816V59.227a2.849 2.849 0 012.849-2.849h7.919l6.158.989 6.654-.989h7.91a2.849 2.849 0 012.849 2.849v33.589a2.849 2.849 0 01-2.849 2.849z"
                        transform="translate(0 -56.378)"
                        fill="url(#prefix__c)"
                    />
                    <path
                        data-name="Path 26198"
                        d="M0 273.194v15a2.849 2.849 0 002.849 2.849h37.188a2.849 2.849 0 002.849-2.849v-15z"
                        transform="translate(0 -251.751)"
                        fill="url(#prefix__b)"
                    />
                </g>
                <path
                    data-name="Path 26199"
                    d="M110.8 64.422l30.522 30.522a2.839 2.839 0 00.958-2.127V75.685l-19.304-19.306-5.937 3.437-6.739 4.047c0 .371.5.559.5.559z"
                    transform="translate(-99.396 -56.379)"
                    fill="url(#prefix__d)"
                />
                <path
                    data-name="Path 26200"
                    d="M108.787 56.378v7.484a.565.565 0 00.964.4.565.565 0 01.8 0 1.814 1.814 0 002.566 0 .565.565 0 01.8 0 1.814 1.814 0 002.566 0 .565.565 0 01.8 0 1.815 1.815 0 002.566 0 .565.565 0 01.8 0 .565.565 0 00.964-.4v-7.484z"
                    transform="translate(-98.028 -56.378)"
                    fill="url(#prefix__e)"
                />
                <g data-name="Group 1585" fill="#3e5959">
                    <path
                        data-name="Path 26201"
                        d="M15.663 28.62H5.216a.6.6 0 01-.6-.6v-.811a.6.6 0 01.6-.6h10.447a.6.6 0 01.6.6v.812a.6.6 0 01-.6.599z"
                    />
                    <path
                        data-name="Path 26202"
                        d="M15.663 31.976H5.216a.6.6 0 01-.6-.6v-.812a.6.6 0 01.6-.6h10.447a.6.6 0 01.6.6v.812a.6.6 0 01-.6.6z"
                    />
                    <path
                        data-name="Path 26203"
                        d="M10.358 35.332H5.216a.6.6 0 01-.6-.6v-.812a.6.6 0 01.6-.6h5.142a.6.6 0 01.6.6v.812a.6.6 0 01-.6.6z"
                    />
                </g>
            </g>
            <path
                data-name="Path 26204"
                d="M298.732 289.733v-14.806h-14.806z"
                transform="translate(-255.846 -253.313)"
                fill="url(#prefix__f)"
            />
            <path
                data-name="Path 26205"
                d="M300.768 168.155l-9.908-6.539a1.676 1.676 0 00-2.6 1.4v3.058h-8.008a1.613 1.613 0 00-1.613 1.613v3.737a1.613 1.613 0 001.613 1.613h8.008v3.058a1.676 1.676 0 002.6 1.4l9.908-6.54a1.676 1.676 0 000-2.8z"
                transform="translate(-251.082 -150.955)"
                fill="url(#prefix__g)"
            />
        </svg>
    )
}

export default ExportSvgComponent